import React from 'react'
import { Box, Flex, Label, Text, Tooltip } from '@workwhile/ui'
import { formatInTimeZone } from 'date-fns-tz'
import { JetCallReportItem } from 'api/admin/jet/listJetCallReports'
import {
  JET_CALL_REPORT_STATUS_LABELS,
  JET_CALL_REPORT_STATUS_LABEL_VARIANTS,
} from 'pages/Jet/shared/constants/status'

const formatOrDash = (value: string | null, timezone: string) =>
  value ? formatInTimeZone(value, timezone, 'EEEE, MMMM d, h:mm a z') : '-'

export const JetStatusBadge = ({ item }: { item: JetCallReportItem }) => {
  const status = item.status

  const tooltipLabel = (
    <Flex flexDirection="column" gap={1}>
      <Text fontWeight="bold">JET clock-out call report:</Text>
      <Text>Work status: {item.workStatus}</Text>
      <Text>Manager: {item.managerName || '-'}</Text>
      <Text>
        Meal break start: {formatOrDash(item.mealBreakStartedAt, item.timezone)}
      </Text>
      <Text>
        Meal break end: {formatOrDash(item.mealBreakEndedAt, item.timezone)}
      </Text>
      <Text>Temp labor ID: {item.tempLaborId || '-'}</Text>
      <Text>
        Timesheet photo:{' '}
        {item.hasTimesheetPhoto
          ? item.timesheetPhotoIsFallback
            ? 'Attached (auto-generated)'
            : 'Attached'
          : 'Not attached'}
      </Text>
      <Text>Synced: {formatOrDash(item.syncedAt, item.timezone)}</Text>
      <Text>
        Last alerted: {formatOrDash(item.lastAlertedAt, item.timezone)}
      </Text>
    </Flex>
  )

  // Show the underlying status inline for `excluded` - it doesn't say why on its own.
  const label =
    status === 'excluded'
      ? `${JET_CALL_REPORT_STATUS_LABELS[status]}: ${item.workStatus}`
      : JET_CALL_REPORT_STATUS_LABELS[status]

  return (
    <Tooltip content={tooltipLabel}>
      <Box as="span">
        <Label
          variant={JET_CALL_REPORT_STATUS_LABEL_VARIANTS[status]}
          size="small"
          style={{ whiteSpace: 'nowrap', padding: '0 0.5rem' }}
        >
          {label}
        </Label>
      </Box>
    </Tooltip>
  )
}
